import { Services } from '../../types/services';

interface Partner {
  id?: string;
  name?: string;
  [key: string]: unknown;
}

interface State {
  partners: Partner[];
}

const initialState: State = {
  partners: [],
};

interface Action {
  type: string;
  payload?: unknown;
}

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosCall = services.axios.Axios();

  const getPartners = () => async () => {
    try {
      const response = await axiosCall.get('partners');
      return (response as unknown as { data: Partner[] }).data;
    } catch (err) {
      console.error(err);
    }
  };

  const getPartner = (partnerId: string) => async () => {
    try {
      const response = await axiosCall.get('partners/' + partnerId);
      return (response as unknown as { data: Partner }).data;
    } catch (err) {
      console.error(err);
    }
  };

  const createNewPartner = (payload: Record<string, unknown>) => async () => {
    return axiosCall.post('partners', { ...payload });
  };

  return {
    createNewPartner,
    getPartner,
    getPartners,
  };
};

